import { THRESHOLD } from "@/constants/preview";

export const calculatePercentageChange = (oldValue, newValue) => {
  // oldValue will almost certainly never be zero, because that would mean a local confirmed a file with zero rows, but just in case I use this function for something else someday without considering this zero issue, having it return 100 instead of infinity seems ok for now.
  if (oldValue === 0) {
    return 100;
  }
  return parseFloat((((newValue - oldValue) / oldValue) * 100).toFixed(2));
};

export const breaksChangeThreshold = (percentage) => {
  if (typeof percentage === "string") {
    return false;
  } else {
    return Math.abs(percentage) > THRESHOLD;
  }
};

export const styledBrokenThreshold = (percentage) => {
  return (
    <span data-testid="scary-span" style={{ color: "red" }}>
      {percentage.toFixed(2)}%
    </span>
  );
};

export const formatPercentageChange = (percentage) => {
  if (percentage === null) {
    return "";
  } else if (typeof percentage === "string") {
    return percentage;
  } else {
    return `${percentage.toFixed(2)}%`;
  }
};

export const formatCurrency = (amount) => {
  if (amount) {
    return "$" + amount.toFixed(2);
  } else {
    return "--";
  }
};

// used to decide if SCARY Confirmation modal should be shown when user attemps to confirm a file
export const percentageChangeBreaksThreshold = (countChanges) => {
  let percentageChange = null;
  if (countChanges) {
    percentageChange = calculatePercentageChange(
      countChanges.prior,
      countChanges.current
    );
  }
  return breaksChangeThreshold(percentageChange);
};

export const getEmployerNameChangeData = (data) => {
  let employerNameData = {};
  // get employer name data
  if (data.field_data) {
    data.field_data.forEach((field) => {
      if (field.field_name === "employer_name") {
        employerNameData = {
          current: field.counts.current,
          prior: field.counts.prior,
        };
        return;
      }
    });
  }
  return employerNameData;
};
